exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.student-attention[data-v-46252d1e] {\n  margin-bottom: 35px;\n}\n.actions .button.delete[data-v-46252d1e] {\n  padding: 0 45px;\n}\n.actions .button.cancel[data-v-46252d1e] {\n  padding: 0 20px;\n}\n", ""]);

// exports
